<div class="background" (click)="globalData.applicationState.showShareDialog = false;"></div>
<dps-share></dps-share>

